import { fromBase64, toBase64 } from '../string-utils';

export const encodePayload = (encodedPayload: Record<string, any>): string => {
  return toBase64(JSON.stringify(encodedPayload));
};

export const parsePayload = (encodedPayload: string): string => {
  return JSON.parse(fromBase64(encodedPayload));
};
